module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/032-zambia-1c574d56427030ea46d7a4f46be27b4a.svg";